import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import CatalogForm from './components/CatalogForm';
import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { CreateSneakerMutation, TagsAndBrandsQuery } from './queries';

class NewCatalog extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { client, push } = this.props;
    return client.mutate({ mutation: CreateSneakerMutation, variables: { record: data } })
      .then(() => push('/catalog'))
      .catch(parseFormErrors);
  }

  render() {
    return (
      <div id="new-catalog">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/catalog">Catalog</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Item</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <CatalogForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

export default compose(
  withGraphqlData(TagsAndBrandsQuery),
  connect(null, { push }),
  withApollo,
)(NewCatalog);
